/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAllFromOfficialRepresentative } from '../all_from_official_representative/AllFromOfficialRepresentative';
import type { IAreaPartPropPresenter } from '../area_part_prop_presenter/AreaPartPropPresenter';
import type { IBargainTermsPresenter } from '../bargain_terms_presenter/BargainTermsPresenter';
import type { IBookingInfoPresenter } from '../booking_info_presenter/BookingInfoPresenter';
import type { IBuildingPresenter } from '../building_presenter/BuildingPresenter';
import type { IBusinessShoppingCenter } from '../business_shopping_center/BusinessShoppingCenter';
import type { ICommunication } from '../communication/Communication';
import type { ICoworkingPresenter } from '../coworking_presenter/CoworkingPresenter';
import type { ICplModeration } from '../cpl_moderation/CplModeration';
import type { IDistrictBtiData } from '../district_bti_data/DistrictBtiData';
import type { IDrainage } from '../drainage/Drainage';
import type { IElectricity } from '../electricity/Electricity';
import type { IFlags } from '../flags/Flags';
import type { IGarage } from '../garage/Garage';
import type { IGas } from '../gas/Gas';
import type { IGeoPresenterListItem } from '../geo_presenter_list_item/GeoPresenterListItem';
import type { IKp } from '../kp/Kp';
import type { ILand } from '../land/Land';
import type { IPhoto } from '../photo/Photo';
import type { IMonthlyIincome } from '../monthly_iincome/MonthlyIincome';
import type { IMultiposting } from '../multiposting/Multiposting';
import type { INewBuildingPresenter } from '../new_building_presenter/NewBuildingPresenter';
import type { INewbuildingDynamicCalltracking } from '../newbuilding_dynamic_calltracking/NewbuildingDynamicCalltracking';
import type { IUserNotes } from '../user_notes/UserNotes';
import type { IPhoneOfferPresenter } from '../phone_offer_presenter/PhoneOfferPresenter';
import type { IPublicOfferPhotoPresenter } from '../public_offer_photo_presenter/PublicOfferPhotoPresenter';
import type { IPlatformObject } from '../platform_object/PlatformObject';
import type { IPriceChangePresenter } from '../price_change_presenter/PriceChangePresenter';
import type { IPromoInfo } from '../promo_info/PromoInfo';
import type { IPublishTerms } from '../publish_terms/PublishTerms';
import type { IOfferRosreestrCheck } from '../offer_rosreestr_check/OfferRosreestrCheck';
import type { ISelfEmployedData } from '../self_employed_data/SelfEmployedData';
import type { ISimilarOffers } from '../similar_offers/SimilarOffers';
import type { ICommercialSpecialty } from '../commercial_specialty/CommercialSpecialty';
import type { IStatistic } from '../statistic/Statistic';
import type { IFastFiltersUserPresenter } from '../fast_filters_user_presenter/FastFiltersUserPresenter';
import type { IVideo } from '../video/Video';
import type { IWater } from '../water/Water';
import type { IWorkTimeInfoPresenter } from '../work_time_info_presenter/WorkTimeInfoPresenter';

export interface IFastFiltersOfferPresenter {
  /** Категория объявления **/
  category: ECategory;
  /** Временный ID объявления/черновика (GUID) **/
  objectGuid: string;
  /** Статус объявления **/
  status: EStatus;
  /** Доступ **/
  accessType?: TFastFiltersOfferPresenter_AccessType;
  /** Дата подачи объявления **/
  added?: TFastFiltersOfferPresenter_Added;
  /** Дата подачи объявления (timestamp) **/
  addedTimestamp?: TFastFiltersOfferPresenter_AddedTimestamp;
  /** Доп. линии **/
  additionalPhoneLinesAllowed?: TFastFiltersOfferPresenter_AdditionalPhoneLinesAllowed;
  /** Данные об объявлениях от офпреда в ТЦ/БЦ пирвязанном к этому объявлению **/
  allFromOffrep?: TFastFiltersOfferPresenter_AllFromOffrep;
  /** Площадь комнат, м2 **/
  allRoomsArea?: TFastFiltersOfferPresenter_AllRoomsArea;
  /** Дата перемещения объявления в архив **/
  archivedDate?: TFastFiltersOfferPresenter_ArchivedDate;
  /** Части площади **/
  areaParts?: TFastFiltersOfferPresenter_AreaParts;
  /** Дата освобождения **/
  availableFrom?: TFastFiltersOfferPresenter_AvailableFrom;
  /** Количество балконов **/
  balconiesCount?: TFastFiltersOfferPresenter_BalconiesCount;
  /** Условия сделки **/
  bargainTerms?: TFastFiltersOfferPresenter_BargainTerms;
  /** Количество спален **/
  bedroomsCount?: TFastFiltersOfferPresenter_BedroomsCount;
  /** Количество спальных мест **/
  bedsCount?: TFastFiltersOfferPresenter_BedsCount;
  /** Информация о бронировании **/
  booking?: TFastFiltersOfferPresenter_Booking;
  /** Уровень брендинга **/
  brandingLevel?: TFastFiltersOfferPresenter_BrandingLevel;
  /** Информация о доме **/
  building?: TFastFiltersOfferPresenter_Building;
  /** Кадастровый номер дома **/
  buildingCadastralNumber?: TFastFiltersOfferPresenter_BuildingCadastralNumber;
  /** БЦ/ТЦ **/
  businessShoppingCenter?: TFastFiltersOfferPresenter_BusinessShoppingCenter;
  /** Кадастровый номер **/
  cadastralNumber?: TFastFiltersOfferPresenter_CadastralNumber;
  /** Тип подключенного calltracking-а **/
  callTrackingProvider?: TFastFiltersOfferPresenter_CallTrackingProvider;
  /** Можно частями **/
  canParts?: TFastFiltersOfferPresenter_CanParts;
  /** Категории **/
  categoriesIds?: TFastFiltersOfferPresenter_CategoriesIds;
  /** Идентификатор чата **/
  chatId?: TFastFiltersOfferPresenter_ChatId;
  /** Можно с детьми **/
  childrenAllowed?: TFastFiltersOfferPresenter_ChildrenAllowed;
  /** ID объявления на ЦИАНе **/
  cianId?: TFastFiltersOfferPresenter_CianId;
  /** ID пользователя в ЦИАНе **/
  cianUserId?: TFastFiltersOfferPresenter_CianUserId;
  /** Количество совместных санузлов **/
  combinedWcsCount?: TFastFiltersOfferPresenter_CombinedWcsCount;
  /** Виды коммуникации с пользователем **/
  communication?: TFastFiltersOfferPresenter_Communication;
  /** Состояние **/
  conditionRatingType?: TFastFiltersOfferPresenter_ConditionRatingType;
  /** Состояние **/
  conditionType?: TFastFiltersOfferPresenter_ConditionType;
  /** Информация о коворкинге **/
  coworking?: TFastFiltersOfferPresenter_Coworking;
  /** Тип помещения в коворкинге **/
  coworkingOfferType?: TFastFiltersOfferPresenter_CoworkingOfferType;
  /** Информация для проверки агента по CPL-схеме **/
  cplModeration?: TFastFiltersOfferPresenter_CplModeration;
  /** Тип сделки **/
  dealType?: TFastFiltersOfferPresenter_DealType;
  /** Отделка **/
  decoration?: TFastFiltersOfferPresenter_Decoration;
  /** Дом подлежит сносу в рамках программы реновации **/
  demolishedInMoscowProgramm?: TFastFiltersOfferPresenter_DemolishedInMoscowProgramm;
  /** Текст объявления **/
  description?: TFastFiltersOfferPresenter_Description;
  /** Minhash текста объявления **/
  descriptionMinhash?: TFastFiltersOfferPresenter_DescriptionMinhash;
  /** Список диапазонов подсвеченных слов **/
  descriptionWordsHighlighted?: TFastFiltersOfferPresenter_DescriptionWordsHighlighted;
  /** Информация о районе **/
  district?: TFastFiltersOfferPresenter_District;
  /** Канализация **/
  drainage?: TFastFiltersOfferPresenter_Drainage;
  /** Объем, м3/сутки **/
  drainageCapacity?: TFastFiltersOfferPresenter_DrainageCapacity;
  /** Тип канализации **/
  drainageType?: TFastFiltersOfferPresenter_DrainageType;
  /** Подъездные пути **/
  drivewayType?: TFastFiltersOfferPresenter_DrivewayType;
  /** ID группы дубликатов объявлений **/
  duplicateGroupId?: TFastFiltersOfferPresenter_DuplicateGroupId;
  /** Дата смены статуса объявления **/
  editDate?: TFastFiltersOfferPresenter_EditDate;
  /** Электроснабжение **/
  electricity?: TFastFiltersOfferPresenter_Electricity;
  /** Мощность, кВТ **/
  electricityPower?: TFastFiltersOfferPresenter_ElectricityPower;
  /** Тип электроснабжения **/
  electricityType?: TFastFiltersOfferPresenter_ElectricityType;
  /** Недвижимость **/
  estateType?: TFastFiltersOfferPresenter_EstateType;
  /** Ссылки для скачивания оффера в виде DOC **/
  exportDocLink?: TFastFiltersOfferPresenter_ExportDocLink;
  /** Ссылки для скачивания оффера в виде PDF **/
  exportPdfLink?: TFastFiltersOfferPresenter_ExportPdfLink;
  /** Внешний ID **/
  externalId?: TFastFiltersOfferPresenter_ExternalId;
  /** Ссылка на оригинальное объявление **/
  externalUrl?: TFastFiltersOfferPresenter_ExternalUrl;
  /** Id склеенных объявлений **/
  feedboxMultiOfferKey?: TFastFiltersOfferPresenter_FeedboxMultiOfferKey;
  /** Флаги состояния объявления **/
  flags?: TFastFiltersOfferPresenter_Flags;
  /** Тип квартиры **/
  flatType?: TFastFiltersOfferPresenter_FlatType;
  /** Этаж с **/
  floorFrom?: TFastFiltersOfferPresenter_FloorFrom;
  /** Материал полов **/
  floorMaterialType?: TFastFiltersOfferPresenter_FloorMaterialType;
  /** Этаж **/
  floorNumber?: TFastFiltersOfferPresenter_FloorNumber;
  /** Этаж по **/
  floorTo?: TFastFiltersOfferPresenter_FloorTo;
  /** От застройщика (аккаунт объявления с тарифом Застройщик) **/
  fromDeveloper?: TFastFiltersOfferPresenter_FromDeveloper;
  /** Ссылка на объявление **/
  fullUrl?: TFastFiltersOfferPresenter_FullUrl;
  /** Мебель **/
  furniture?: TFastFiltersOfferPresenter_Furniture;
  /** Мебель **/
  furniturePresence?: TFastFiltersOfferPresenter_FurniturePresence;
  /** Google analytics label **/
  gaLabel?: TFastFiltersOfferPresenter_GaLabel;
  /** Тип гаража **/
  garage?: TFastFiltersOfferPresenter_Garage;
  /** Газоснабжение **/
  gas?: TFastFiltersOfferPresenter_Gas;
  /** Емкость, м3/час **/
  gasCapacity?: TFastFiltersOfferPresenter_GasCapacity;
  /** Давление, Мпа **/
  gasPressure?: TFastFiltersOfferPresenter_GasPressure;
  /** Тип газоснабжения **/
  gasType?: TFastFiltersOfferPresenter_GasType;
  /** Представление гео элементов **/
  geo?: TFastFiltersOfferPresenter_Geo;
  /** Есть баня **/
  hasBathhouse?: TFastFiltersOfferPresenter_HasBathhouse;
  /** Есть ванна **/
  hasBathtub?: TFastFiltersOfferPresenter_HasBathtub;
  /** Заселение 24 часа **/
  hasCheckIn_24?: TFastFiltersOfferPresenter_HasCheckIn_24;
  /** Есть кондиционер **/
  hasConditioner?: TFastFiltersOfferPresenter_HasConditioner;
  /** Есть посудомоечная машина **/
  hasDishwasher?: TFastFiltersOfferPresenter_HasDishwasher;
  /** Есть канализация **/
  hasDrainage?: TFastFiltersOfferPresenter_HasDrainage;
  /** Есть электричество **/
  hasElectricity?: TFastFiltersOfferPresenter_HasElectricity;
  /** Есть обременение **/
  hasEncumbrances?: TFastFiltersOfferPresenter_HasEncumbrances;
  /** Есть оборудование **/
  hasEquipment?: TFastFiltersOfferPresenter_HasEquipment;
  /** Организация экскурсий **/
  hasExcursions?: TFastFiltersOfferPresenter_HasExcursions;
  /** Есть система пожаротушения **/
  hasExtinguishingSystem?: TFastFiltersOfferPresenter_HasExtinguishingSystem;
  /** Есть холодильник **/
  hasFridge?: TFastFiltersOfferPresenter_HasFridge;
  /** Есть мебель (в комнатах для живой) **/
  hasFurniture?: TFastFiltersOfferPresenter_HasFurniture;
  /** Есть гараж **/
  hasGarage?: TFastFiltersOfferPresenter_HasGarage;
  /** Есть газ **/
  hasGas?: TFastFiltersOfferPresenter_HasGas;
  /** Фен **/
  hasHairdryer?: TFastFiltersOfferPresenter_HasHairdryer;
  /** Есть отопление **/
  hasHeating?: TFastFiltersOfferPresenter_HasHeating;
  /** Есть интернет **/
  hasInternet?: TFastFiltersOfferPresenter_HasInternet;
  /** Есть инвестпроект **/
  hasInvestmentProject?: TFastFiltersOfferPresenter_HasInvestmentProject;
  /** Утюг **/
  hasIron?: TFastFiltersOfferPresenter_HasIron;
  /** Джакузи **/
  hasJacuzzi?: TFastFiltersOfferPresenter_HasJacuzzi;
  /** Есть мебель на кухне **/
  hasKitchenFurniture?: TFastFiltersOfferPresenter_HasKitchenFurniture;
  /** Есть лифт **/
  hasLift?: TFastFiltersOfferPresenter_HasLift;
  /** Есть свет **/
  hasLight?: TFastFiltersOfferPresenter_HasLight;
  /** Есть парковка **/
  hasParking?: TFastFiltersOfferPresenter_HasParking;
  /** Есть телефон **/
  hasPhone?: TFastFiltersOfferPresenter_HasPhone;
  /** Есть бассейн **/
  hasPool?: TFastFiltersOfferPresenter_HasPool;
  /** Пандус (есть/нет) **/
  hasRamp?: TFastFiltersOfferPresenter_HasRamp;
  /** Ответственное хранение **/
  hasSafeCustody?: TFastFiltersOfferPresenter_HasSafeCustody;
  /** Документы командированным **/
  hasSecondedDocs?: TFastFiltersOfferPresenter_HasSecondedDocs;
  /** Есть охрана **/
  hasSecurity?: TFastFiltersOfferPresenter_HasSecurity;
  /** Есть витринные окна **/
  hasShopWindows?: TFastFiltersOfferPresenter_HasShopWindows;
  /** Есть душевая кабина **/
  hasShower?: TFastFiltersOfferPresenter_HasShower;
  /** Чай-кофе-сахар **/
  hasTeaCoffeeSugar?: TFastFiltersOfferPresenter_HasTeaCoffeeSugar;
  /** Трансфер **/
  hasTransfer?: TFastFiltersOfferPresenter_HasTransfer;
  /** Транспортные услуги **/
  hasTransportServices?: TFastFiltersOfferPresenter_HasTransportServices;
  /** Есть телевизор **/
  hasTv?: TFastFiltersOfferPresenter_HasTv;
  /** Есть стиральная машина **/
  hasWasher?: TFastFiltersOfferPresenter_HasWasher;
  /** Есть водоснабжение **/
  hasWater?: TFastFiltersOfferPresenter_HasWater;
  /** Есть Wi-Fi **/
  hasWifi?: TFastFiltersOfferPresenter_HasWifi;
  /** Платные ТВ-каналы **/
  hasWiredInternet?: TFastFiltersOfferPresenter_HasWiredInternet;
  /** Список всех проверок, которые прошел пользователь **/
  homeownerProofs?: TFastFiltersOfferPresenter_HomeownerProofs;
  /** Относительная дата подачи объявления **/
  humanizedTimedelta?: TFastFiltersOfferPresenter_HumanizedTimedelta;
  /** ID объявления в Realty **/
  id?: TFastFiltersOfferPresenter_Id;
  /** Вход **/
  inputType?: TFastFiltersOfferPresenter_InputType;
  /** Апартаменты **/
  isApartments?: TFastFiltersOfferPresenter_IsApartments;
  /** Аукцион **/
  isAuction?: TFastFiltersOfferPresenter_IsAuction;
  /** Объявление от собственника коммерческой **/
  isByCommercialOwner?: TFastFiltersOfferPresenter_IsByCommercialOwner;
  /** Объявление от собственника **/
  isByHomeowner?: TFastFiltersOfferPresenter_IsByHomeowner;
  /** Объявление от партнера **/
  isCianPartner?: TFastFiltersOfferPresenter_IsCianPartner;
  /** Выделение цветом **/
  isColorized?: TFastFiltersOfferPresenter_IsColorized;
  /** Таможня **/
  isCustoms?: TFastFiltersOfferPresenter_IsCustoms;
  /** Дача **/
  isDacha?: TFastFiltersOfferPresenter_IsDacha;
  /** Подменяли ли номер застройщика для сделки **/
  isDealRequestSubstitutionPhone?: TFastFiltersOfferPresenter_IsDealRequestSubstitutionPhone;
  /** Дубликат или оригинал **/
  isDuplicate?: TFastFiltersOfferPresenter_IsDuplicate;
  /** Дублирующееся описание **/
  isDuplicatedDescription?: TFastFiltersOfferPresenter_IsDuplicatedDescription;
  /** Подключен ли колтрекинг **/
  isEnabledCallTracking?: TFastFiltersOfferPresenter_IsEnabledCallTracking;
  /** Флаг пессимизации, в объявлении встречаются ошибки **/
  isExcludedFromAction?: TFastFiltersOfferPresenter_IsExcludedFromAction;
  /** Работаем честно **/
  isFairplay?: TFastFiltersOfferPresenter_IsFairplay;
  /** В избранном **/
  isFavorite?: TFastFiltersOfferPresenter_IsFavorite;
  /** Является ли объявлением от застройщика (застройщик, не представитель) **/
  isFromBuilder?: TFastFiltersOfferPresenter_IsFromBuilder;
  /** Скрыто ли объявление пользователем **/
  isHiddenByUser?: TFastFiltersOfferPresenter_IsHiddenByUser;
  /** Из импорта ли объявление **/
  isImported?: TFastFiltersOfferPresenter_IsImported;
  /** Объявление закрытой базы **/
  isInHiddenBase?: TFastFiltersOfferPresenter_IsInHiddenBase;
  /** Юр. адрес предоставляется (да/нет) **/
  isLegalAddressProvided?: TFastFiltersOfferPresenter_IsLegalAddressProvided;
  /** Является ли объявление мультиофером **/
  isMulti?: TFastFiltersOfferPresenter_IsMulti;
  /** Скрывать точный адрес для отображения **/
  isNeedHideExactAddress?: TFastFiltersOfferPresenter_IsNeedHideExactAddress;
  /** Нужно добавить иконку "Новое" **/
  isNew?: TFastFiltersOfferPresenter_IsNew;
  /** Помещение занято **/
  isOccupied?: TFastFiltersOfferPresenter_IsOccupied;
  /** Платное **/
  isPaid?: TFastFiltersOfferPresenter_IsPaid;
  /** Пентхаус **/
  isPenthouse?: TFastFiltersOfferPresenter_IsPenthouse;
  /** Премиум **/
  isPremium?: TFastFiltersOfferPresenter_IsPremium;
  /** Значок профессионала **/
  isPro?: TFastFiltersOfferPresenter_IsPro;
  /** Включена ли возможность показов **/
  isRealtyDemonstrationEnabled?: TFastFiltersOfferPresenter_IsRealtyDemonstrationEnabled;
  /** Флаг пессимизации, рецидивист **/
  isRecidivist?: TFastFiltersOfferPresenter_IsRecidivist;
  /** Сдается ли в аренду частями **/
  isRentByParts?: TFastFiltersOfferPresenter_IsRentByParts;
  /** Стандарт **/
  isStandard?: TFastFiltersOfferPresenter_IsStandard;
  /** Топ **/
  isTop3?: TFastFiltersOfferPresenter_IsTop3;
  /** Ссылка на ЖК **/
  jkUrl?: TFastFiltersOfferPresenter_JkUrl;
  /** Площадь кухни, м2 **/
  kitchenArea?: TFastFiltersOfferPresenter_KitchenArea;
  /** Коттеджный поселок **/
  kp?: TFastFiltersOfferPresenter_Kp;
  /** Информация об участке **/
  land?: TFastFiltersOfferPresenter_Land;
  /** Планировка **/
  layout?: TFastFiltersOfferPresenter_Layout;
  /** Планировка **/
  layoutPhoto?: TFastFiltersOfferPresenter_LayoutPhoto;
  /** Инфраструктура и досуг **/
  leisure?: TFastFiltersOfferPresenter_Leisure;
  /** Жилая площадь, м2 **/
  livingArea?: TFastFiltersOfferPresenter_LivingArea;
  /** Количество лоджий **/
  loggiasCount?: TFastFiltersOfferPresenter_LoggiasCount;
  /** Максимальная площадь **/
  maxArea?: TFastFiltersOfferPresenter_MaxArea;
  /** Площадь от **/
  minArea?: TFastFiltersOfferPresenter_MinArea;
  /** Минимальная цена за весь объект **/
  minPriceTotal?: TFastFiltersOfferPresenter_MinPriceTotal;
  /** Минимальная цена за весь объект в месяц **/
  minPriceTotalPerMonth?: TFastFiltersOfferPresenter_MinPriceTotalPerMonth;
  /** Цена за весь объект за минимальную возможную площадь в месяц в рублях **/
  minPriceTotalPerMonthRur?: TFastFiltersOfferPresenter_MinPriceTotalPerMonthRur;
  /** Цена за весь объект в месяц за минимальную возможную площадь для поиска **/
  minPriceTotalPerMonthRurForSearch?: TFastFiltersOfferPresenter_MinPriceTotalPerMonthRurForSearch;
  /** Цена за весь объект за минимальную возможную площадь в рублях **/
  minPriceTotalRur?: TFastFiltersOfferPresenter_MinPriceTotalRur;
  /** Цена за весь объект за минимальную возможную площадь для поиска **/
  minPriceTotalRurForSearch?: TFastFiltersOfferPresenter_MinPriceTotalRurForSearch;
  /** НДС за весь объект в месяц за минимальную возможную площадь **/
  minVatPriceTotalPerMonthRur?: TFastFiltersOfferPresenter_MinVatPriceTotalPerMonthRur;
  /** НДС за весь объект за минимальную возможную площадь **/
  minVatPriceTotalRur?: TFastFiltersOfferPresenter_MinVatPriceTotalRur;
  /** Месячная прибыль **/
  monthlyIncome?: TFastFiltersOfferPresenter_MonthlyIncome;
  /** Информация о Мультипостинге **/
  multiposting?: TFastFiltersOfferPresenter_Multiposting;
  /** Наименование **/
  name?: TFastFiltersOfferPresenter_Name;
  /** Объект NewBuilding **/
  newbuilding?: TFastFiltersOfferPresenter_Newbuilding;
  /** Данные о динамическом calltracking новостроек **/
  newbuildingDynamicCalltracking?: TFastFiltersOfferPresenter_NewbuildingDynamicCalltracking;
  /** Текст промо **/
  newobjectPromoLabel?: TFastFiltersOfferPresenter_NewobjectPromoLabel;
  /** Заметки пользователя **/
  notes?: TFastFiltersOfferPresenter_Notes;
  /** Тип недвижимости **/
  offerType?: TFastFiltersOfferPresenter_OfferType;
  /** Вид разрешенного использования (ВРИ) **/
  permittedUseType?: TFastFiltersOfferPresenter_PermittedUseType;
  /** Можно с животными **/
  petsAllowed?: TFastFiltersOfferPresenter_PetsAllowed;
  /** Кол-во телефонных линий **/
  phoneLinesCount?: TFastFiltersOfferPresenter_PhoneLinesCount;
  /** Нормализованный номер телефона **/
  phones?: TFastFiltersOfferPresenter_Phones;
  /** Фотографии **/
  photos?: TFastFiltersOfferPresenter_Photos;
  /** Тип помещения **/
  placementType?: TFastFiltersOfferPresenter_PlacementType;
  /** Платформа подачи объявления **/
  platform?: TFastFiltersOfferPresenter_Platform;
  /** Возможно изменить ВРИ **/
  possibleToChangePermittedUseType?: TFastFiltersOfferPresenter_PossibleToChangePermittedUseType;
  /** История изменения цены **/
  priceChanges?: TFastFiltersOfferPresenter_PriceChanges;
  /** Цена за единицу площади **/
  pricePerUnitArea?: TFastFiltersOfferPresenter_PricePerUnitArea;
  /** Цена за единицу площади **/
  pricePerUnitAreaEur?: TFastFiltersOfferPresenter_PricePerUnitAreaEur;
  /** Цена за кв.м. в месяц **/
  pricePerUnitAreaPerMonth?: TFastFiltersOfferPresenter_PricePerUnitAreaPerMonth;
  /** Цена за кв.м. в месяц (руб) **/
  pricePerUnitAreaPerMonthRur?: TFastFiltersOfferPresenter_PricePerUnitAreaPerMonthRur;
  /** Цена за кв.м. в месяц (руб) для поиска **/
  pricePerUnitAreaPerMonthRurForSearch?: TFastFiltersOfferPresenter_PricePerUnitAreaPerMonthRurForSearch;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYear?: TFastFiltersOfferPresenter_PricePerUnitAreaPerYear;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearEur?: TFastFiltersOfferPresenter_PricePerUnitAreaPerYearEur;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearRur?: TFastFiltersOfferPresenter_PricePerUnitAreaPerYearRur;
  /** Цена за кв.м. в год для поиска **/
  pricePerUnitAreaPerYearRurForSearch?: TFastFiltersOfferPresenter_PricePerUnitAreaPerYearRurForSearch;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearUsd?: TFastFiltersOfferPresenter_PricePerUnitAreaPerYearUsd;
  /** Цена за единицу площади **/
  pricePerUnitAreaRur?: TFastFiltersOfferPresenter_PricePerUnitAreaRur;
  /** Цена за единицу площади для поиска **/
  pricePerUnitAreaRurForSearch?: TFastFiltersOfferPresenter_PricePerUnitAreaRurForSearch;
  /** Цена за единицу площади **/
  pricePerUnitAreaUsd?: TFastFiltersOfferPresenter_PricePerUnitAreaUsd;
  /** Максимальная цена **/
  priceTotal?: TFastFiltersOfferPresenter_PriceTotal;
  /** Цена за весь объект **/
  priceTotalEur?: TFastFiltersOfferPresenter_PriceTotalEur;
  /** Максимальная цена в месяц **/
  priceTotalPerMonth?: TFastFiltersOfferPresenter_PriceTotalPerMonth;
  /** Цена за весь объект в месяц **/
  priceTotalPerMonthEur?: TFastFiltersOfferPresenter_PriceTotalPerMonthEur;
  /** Максимальная цена в месяц в рублях **/
  priceTotalPerMonthRur?: TFastFiltersOfferPresenter_PriceTotalPerMonthRur;
  /** Цена за весь объект в месяц для поиска **/
  priceTotalPerMonthRurForSearch?: TFastFiltersOfferPresenter_PriceTotalPerMonthRurForSearch;
  /** Цена за весь объект в месяц **/
  priceTotalPerMonthUsd?: TFastFiltersOfferPresenter_PriceTotalPerMonthUsd;
  /** Максимальная цена в рублях **/
  priceTotalRur?: TFastFiltersOfferPresenter_PriceTotalRur;
  /** Цена за весь объект для поиска **/
  priceTotalRurForSearch?: TFastFiltersOfferPresenter_PriceTotalRurForSearch;
  /** Цена за весь объект **/
  priceTotalUsd?: TFastFiltersOfferPresenter_PriceTotalUsd;
  /** Количество дублей в группе профпоиска **/
  professionalSearchDuplicatesGroupSize?: TFastFiltersOfferPresenter_ProfessionalSearchDuplicatesGroupSize;
  /** Проектная декларация **/
  projectDeclarationUrl?: TFastFiltersOfferPresenter_ProjectDeclarationUrl;
  /** Рекламные акции **/
  promoInfo?: TFastFiltersOfferPresenter_PromoInfo;
  /** Тип недвижимости **/
  propertyType?: TFastFiltersOfferPresenter_PropertyType;
  /** Условия размещения объявления **/
  publishTerms?: TFastFiltersOfferPresenter_PublishTerms;
  /** Realty ID пользователя, из под которого показывается объявление **/
  publishedUserId?: TFastFiltersOfferPresenter_PublishedUserId;
  /** Тип готового бизнеса **/
  readyBusinessType?: TFastFiltersOfferPresenter_ReadyBusinessType;
  /** Описание сдачи части в аренду **/
  rentByPartsDescription?: TFastFiltersOfferPresenter_RentByPartsDescription;
  /** Тип ремонта **/
  repairType?: TFastFiltersOfferPresenter_RepairType;
  /** Площадь комнаты (комната, койко-место) **/
  roomArea?: TFastFiltersOfferPresenter_RoomArea;
  /** Тип комнаты (комната) **/
  roomType?: TFastFiltersOfferPresenter_RoomType;
  /** Площадь комнат **/
  roomsArea?: TFastFiltersOfferPresenter_RoomsArea;
  /** Количество комнат **/
  roomsCount?: TFastFiltersOfferPresenter_RoomsCount;
  /** Количество комнат в продажу/аренду **/
  roomsForSaleCount?: TFastFiltersOfferPresenter_RoomsForSaleCount;
  /** Статус проверки в росреестре **/
  rosreestrCheck?: TFastFiltersOfferPresenter_RosreestrCheck;
  /** Данные по самозанятому пользователю **/
  selfEmployedData?: TFastFiltersOfferPresenter_SelfEmployedData;
  /** Количество раздельных санузлов **/
  separateWcsCount?: TFastFiltersOfferPresenter_SeparateWcsCount;
  /** Название коттеджного поселка **/
  settlementName?: TFastFiltersOfferPresenter_SettlementName;
  /** Размер доли (доля в квартире, доля в доме) **/
  shareAmount?: TFastFiltersOfferPresenter_ShareAmount;
  /** Показывать ли предупреждение о недопустимости предоплаты **/
  showWarningMessage?: TFastFiltersOfferPresenter_ShowWarningMessage;
  /** Querystring объявлений в этом доме **/
  similar?: TFastFiltersOfferPresenter_Similar;
  /** Возможное назначение **/
  specialty?: TFastFiltersOfferPresenter_Specialty;
  /** Статистика **/
  statistic?: TFastFiltersOfferPresenter_Statistic;
  /** Номер налоговой **/
  taxNumber?: TFastFiltersOfferPresenter_TaxNumber;
  /** Заголовок объявления **/
  title?: TFastFiltersOfferPresenter_Title;
  /** Общая площадь, м2 **/
  totalArea?: TFastFiltersOfferPresenter_TotalArea;
  /** Информация о пользователе **/
  user?: TFastFiltersOfferPresenter_User;
  /** ID пользователя в Realty **/
  userId?: TFastFiltersOfferPresenter_UserId;
  /** Тип ML ранжирования **/
  vasType?: TFastFiltersOfferPresenter_VasType;
  /** НДС за весь объект в месяц **/
  vatPriceTotalPerMonthRur?: TFastFiltersOfferPresenter_VatPriceTotalPerMonthRur;
  /** НДС за весь объект **/
  vatPriceTotalRur?: TFastFiltersOfferPresenter_VatPriceTotalRur;
  /** Список добавленных видео **/
  videos?: TFastFiltersOfferPresenter_Videos;
  /** Сельская ипотека **/
  villageMortgageAllowed?: TFastFiltersOfferPresenter_VillageMortgageAllowed;
  /** Водоснабжение **/
  water?: TFastFiltersOfferPresenter_Water;
  /** Объем, м3/сутки **/
  waterCapacity?: TFastFiltersOfferPresenter_WaterCapacity;
  /** Кол-во мокрых точек **/
  waterPipesCount?: TFastFiltersOfferPresenter_WaterPipesCount;
  /** Тип водоснабжения **/
  waterType?: TFastFiltersOfferPresenter_WaterType;
  /** Расположение санузла **/
  wcLocationType?: TFastFiltersOfferPresenter_WcLocationType;
  /** Тип санузла (комната) **/
  wcType?: TFastFiltersOfferPresenter_WcType;
  /** Куда выходят окна **/
  windowsViewType?: TFastFiltersOfferPresenter_WindowsViewType;
  /** Наличие коммиссии в пользу риэлтора за заключение договора для аредатора **/
  withoutClientFee?: TFastFiltersOfferPresenter_WithoutClientFee;
  /** Часы работы **/
  workTimeInfo?: TFastFiltersOfferPresenter_WorkTimeInfo;
  /** Количество рабочих мест в помещении **/
  workplaceCount?: TFastFiltersOfferPresenter_WorkplaceCount;
}

export enum ECategory {
  /** Аренда койко-места **/
  BedRent = 'bedRent',
  /** Аренда здания **/
  BuildingRent = 'buildingRent',
  /** Продажа здания **/
  BuildingSale = 'buildingSale',
  /** Аренда готового бизнеса **/
  BusinessRent = 'businessRent',
  /** Продажа готового бизнеса **/
  BusinessSale = 'businessSale',
  /** Аренда автосервис **/
  CarServiceRent = 'carServiceRent',
  /** Продажа автосервиса **/
  CarServiceSale = 'carServiceSale',
  /** Аренда коммерческой земли **/
  CommercialLandRent = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  CommercialLandSale = 'commercialLandSale',
  /** Аренда коттеджа **/
  CottageRent = 'cottageRent',
  /** Продажа коттеджа **/
  CottageSale = 'cottageSale',
  /** Посуточная аренда койко-места **/
  DailyBedRent = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  DailyFlatRent = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  DailyHouseRent = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  DailyRoomRent = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  DomesticServicesRent = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  DomesticServicesSale = 'domesticServicesSale',
  /** Аренда квартиры **/
  FlatRent = 'flatRent',
  /** Продажа квартиры **/
  FlatSale = 'flatSale',
  /** Продажа доли в квартире **/
  FlatShareSale = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  FreeAppointmentObjectRent = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  FreeAppointmentObjectSale = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  GarageRent = 'garageRent',
  /** Продажа гаража **/
  GarageSale = 'garageSale',
  /** Аренда дома/дачи **/
  HouseRent = 'houseRent',
  /** Продажа дома/дачи **/
  HouseSale = 'houseSale',
  /** Аренда части дома **/
  HouseShareRent = 'houseShareRent',
  /** Продажа части дома **/
  HouseShareSale = 'houseShareSale',
  /** Аренда производства **/
  IndustryRent = 'industryRent',
  /** Продажа производство **/
  IndustrySale = 'industrySale',
  /** Продажа участка **/
  LandSale = 'landSale',
  /** Продажа квартиры в новостройке **/
  NewBuildingFlatSale = 'newBuildingFlatSale',
  /** Аренда офиса **/
  OfficeRent = 'officeRent',
  /** Продажа офиса **/
  OfficeSale = 'officeSale',
  /** Аренда общепита **/
  PublicCateringRent = 'publicCateringRent',
  /** Продажа общепита **/
  PublicCateringSale = 'publicCateringSale',
  /** Аренда комнаты **/
  RoomRent = 'roomRent',
  /** Продажа комнаты **/
  RoomSale = 'roomSale',
  /** Аренда торговой площади **/
  ShoppingAreaRent = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  ShoppingAreaSale = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  TownhouseRent = 'townhouseRent',
  /** Продажа таунхауса **/
  TownhouseSale = 'townhouseSale',
  /** Аренда склада **/
  WarehouseRent = 'warehouseRent',
  /** Продажа склада **/
  WarehouseSale = 'warehouseSale',
}
export enum EStatus {
  /** Заблокировано **/
  Blocked = 'blocked',
  /** Деактивировано **/
  Deactivated = 'deactivated',
  /** Удалено **/
  Deleted = 'deleted',
  /** Черновик **/
  Draft = 'draft',
  /** Промодерировано **/
  Moderate = 'moderate',
  /** Опубликовано **/
  Published = 'published',
  /** Отклонено **/
  Refused = 'refused',
  /** Удалено модератором **/
  RemovedByModerator = 'removedByModerator',
  /** Продано **/
  Sold = 'sold',
}
export type TFastFiltersOfferPresenter_AccessType = null | EAccessType;

export enum EAccessType {
  /** Свободный **/
  Free = 'free',
  /** Пропускная система **/
  PassSystem = 'passSystem',
}
export type TFastFiltersOfferPresenter_Added = null | string;

export type TFastFiltersOfferPresenter_AddedTimestamp = null | number;

export type TFastFiltersOfferPresenter_AdditionalPhoneLinesAllowed = null | boolean;

export type TFastFiltersOfferPresenter_AllFromOffrep = null | IAllFromOfficialRepresentative;

export type TFastFiltersOfferPresenter_AllRoomsArea = null | string;

export type TFastFiltersOfferPresenter_ArchivedDate = null | string;

export type TFastFiltersOfferPresenter_AreaParts = null | TFastFiltersOfferPresenter_AreaParts_1;

export type TFastFiltersOfferPresenter_AreaParts_1 = IAreaPartPropPresenter[];

export type TFastFiltersOfferPresenter_AvailableFrom = null | string;

export type TFastFiltersOfferPresenter_BalconiesCount = null | number;

export type TFastFiltersOfferPresenter_BargainTerms = null | IBargainTermsPresenter;

export type TFastFiltersOfferPresenter_BedroomsCount = null | number;

export type TFastFiltersOfferPresenter_BedsCount = null | number;

export type TFastFiltersOfferPresenter_Booking = null | IBookingInfoPresenter;

export type TFastFiltersOfferPresenter_BrandingLevel = null | boolean;

export type TFastFiltersOfferPresenter_Building = null | IBuildingPresenter;

export type TFastFiltersOfferPresenter_BuildingCadastralNumber = null | string;

export type TFastFiltersOfferPresenter_BusinessShoppingCenter = null | IBusinessShoppingCenter;

export type TFastFiltersOfferPresenter_CadastralNumber = null | string;

export type TFastFiltersOfferPresenter_CallTrackingProvider = null | ECallTrackingProvider;

export enum ECallTrackingProvider {
  /** Билайн **/
  Beeline = 'beeline',
  /** МТС **/
  Mts = 'mts',
  /** MTT **/
  Mtt = 'mtt',
}
export type TFastFiltersOfferPresenter_CanParts = null | boolean;

export type TFastFiltersOfferPresenter_CategoriesIds = null | number[];

export type TFastFiltersOfferPresenter_ChatId = null | string;

export type TFastFiltersOfferPresenter_ChildrenAllowed = null | boolean;

export type TFastFiltersOfferPresenter_CianId = null | number;

export type TFastFiltersOfferPresenter_CianUserId = null | number;

export type TFastFiltersOfferPresenter_CombinedWcsCount = null | number;

export type TFastFiltersOfferPresenter_Communication = null | ICommunication;

export type TFastFiltersOfferPresenter_ConditionRatingType = null | EConditionRatingType;

export enum EConditionRatingType {
  /** Отличное **/
  Excellent = 'excellent',
  /** Хорошее **/
  Good = 'good',
  /** Удовлетворительное **/
  Satisfactory = 'satisfactory',
}
export type TFastFiltersOfferPresenter_ConditionType = null | EConditionType;

export enum EConditionType {
  /** Требуется косметический ремонт **/
  CosmeticRepairsRequired = 'cosmeticRepairsRequired',
  /** Дизайнерский ремонт **/
  Design = 'design',
  /** Под чистовую отделку **/
  Finishing = 'finishing',
  /** Требуется капитальный ремонт **/
  MajorRepairsRequired = 'majorRepairsRequired',
  /** Офисная отделка **/
  Office = 'office',
  /** Типовой ремонт **/
  Typical = 'typical',
}
export type TFastFiltersOfferPresenter_Coworking = null | ICoworkingPresenter;

export type TFastFiltersOfferPresenter_CoworkingOfferType = null | ECoworkingOfferType;

export enum ECoworkingOfferType {
  /** Конференц-зал **/
  ConferenceHall = 'conferenceHall',
  /** Закрепленное рабочее место **/
  FixedWorkplace = 'fixedWorkplace',
  /** Незакрепленное рабочее место **/
  FlexibleWorkplace = 'flexibleWorkplace',
  /** Переговорная комната **/
  MeetingRoom = 'meetingRoom',
  /** Офис **/
  Office = 'office',
}
export type TFastFiltersOfferPresenter_CplModeration = null | ICplModeration;

export type TFastFiltersOfferPresenter_DealType = null | EDealType;

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}
export type TFastFiltersOfferPresenter_Decoration = null | EDecoration;

export enum EDecoration {
  /** Чистовая **/
  Fine = 'fine',
  /** Черновая **/
  Rough = 'rough',
  /** Без отделки **/
  Without = 'without',
}
export type TFastFiltersOfferPresenter_DemolishedInMoscowProgramm = null | boolean;

export type TFastFiltersOfferPresenter_Description = null | string;

export type TFastFiltersOfferPresenter_DescriptionMinhash = null | string;

export type TFastFiltersOfferPresenter_DescriptionWordsHighlighted =
  null | TFastFiltersOfferPresenter_DescriptionWordsHighlighted_1;

export type TFastFiltersOfferPresenter_DescriptionWordsHighlighted_1 = number[][];

export type TFastFiltersOfferPresenter_District = null | IDistrictBtiData;

export type TFastFiltersOfferPresenter_Drainage = null | IDrainage;

export type TFastFiltersOfferPresenter_DrainageCapacity = null | number;

export type TFastFiltersOfferPresenter_DrainageType = null | EDrainageType;

export enum EDrainageType {
  /** Автономная **/
  Autonomous = 'autonomous',
  /** Центральная **/
  Central = 'central',
  /** Выгребная яма **/
  Cesspool = 'cesspool',
  /** Септик **/
  SepticTank = 'septicTank',
  /** Ливневая **/
  Storm = 'storm',
  /** Очистные сооружения **/
  TreatmentFacilities = 'treatmentFacilities',
}
export type TFastFiltersOfferPresenter_DrivewayType = null | EDrivewayType;

export enum EDrivewayType {
  /** Асфальтированная дорога **/
  Asphalt = 'asphalt',
  /** Грунтовая дорога **/
  Ground = 'ground',
  /** Нет **/
  No = 'no',
}
export type TFastFiltersOfferPresenter_DuplicateGroupId = null | number;

export type TFastFiltersOfferPresenter_EditDate = null | string;

export type TFastFiltersOfferPresenter_Electricity = null | IElectricity;

export type TFastFiltersOfferPresenter_ElectricityPower = null | number;

export type TFastFiltersOfferPresenter_ElectricityType = null | EElectricityType;

export enum EElectricityType {
  /** По границе участка **/
  Border = 'border',
  /** На участке **/
  Location = 'location',
  /** Нет **/
  No = 'no',
}
export type TFastFiltersOfferPresenter_EstateType = null | EEstateType;

export enum EEstateType {
  /** В собственности **/
  Owned = 'owned',
  /** В аренде **/
  Rent = 'rent',
}
export type TFastFiltersOfferPresenter_ExportDocLink = null | string;

export type TFastFiltersOfferPresenter_ExportPdfLink = null | string;

export type TFastFiltersOfferPresenter_ExternalId = null | string;

export type TFastFiltersOfferPresenter_ExternalUrl = null | string;

export type TFastFiltersOfferPresenter_FeedboxMultiOfferKey = null | string;

export type TFastFiltersOfferPresenter_Flags = null | IFlags;

export type TFastFiltersOfferPresenter_FlatType = null | EFlatType;

export enum EFlatType {
  /** Свободная планировка **/
  OpenPlan = 'openPlan',
  /** Комнаты **/
  Rooms = 'rooms',
  /** Студия **/
  Studio = 'studio',
}
export type TFastFiltersOfferPresenter_FloorFrom = null | number;

export type TFastFiltersOfferPresenter_FloorMaterialType = null | EFloorMaterialType;

export enum EFloorMaterialType {
  /** Асфальт **/
  Asphalt = 'asphalt',
  /** Бетон **/
  Concrete = 'concrete',
  /** Ламинат **/
  Laminate = 'laminate',
  /** Линолеум **/
  Linoleum = 'linoleum',
  /** Полимерный **/
  Polymeric = 'polymeric',
  /** Железобетон **/
  ReinforcedConcrete = 'reinforcedConcrete',
  /** Наливной пол **/
  SelfLeveling = 'selfLeveling',
  /** Плитка **/
  Tile = 'tile',
  /** Дерево **/
  Wood = 'wood',
}
export type TFastFiltersOfferPresenter_FloorNumber = null | number;

export type TFastFiltersOfferPresenter_FloorTo = null | number;

export type TFastFiltersOfferPresenter_FromDeveloper = null | boolean;

export type TFastFiltersOfferPresenter_FullUrl = null | string;

export type TFastFiltersOfferPresenter_Furniture = null | string;

export type TFastFiltersOfferPresenter_FurniturePresence = null | EFurniturePresence;

export enum EFurniturePresence {
  /** Нет **/
  No = 'no',
  /** По желанию **/
  Optional = 'optional',
  /** Есть **/
  Yes = 'yes',
}
export type TFastFiltersOfferPresenter_GaLabel = null | string;

export type TFastFiltersOfferPresenter_Garage = null | IGarage;

export type TFastFiltersOfferPresenter_Gas = null | IGas;

export type TFastFiltersOfferPresenter_GasCapacity = null | number;

export type TFastFiltersOfferPresenter_GasPressure = null | number;

export type TFastFiltersOfferPresenter_GasType = null | EGasType;

export enum EGasType {
  /** По границе участка **/
  Border = 'border',
  /** На участке **/
  Location = 'location',
  /** Нет **/
  No = 'no',
}
export type TFastFiltersOfferPresenter_Geo = null | IGeoPresenterListItem;

export type TFastFiltersOfferPresenter_HasBathhouse = null | boolean;

export type TFastFiltersOfferPresenter_HasBathtub = null | boolean;

export type TFastFiltersOfferPresenter_HasCheckIn_24 = null | boolean;

export type TFastFiltersOfferPresenter_HasConditioner = null | boolean;

export type TFastFiltersOfferPresenter_HasDishwasher = null | boolean;

export type TFastFiltersOfferPresenter_HasDrainage = null | boolean;

export type TFastFiltersOfferPresenter_HasElectricity = null | boolean;

export type TFastFiltersOfferPresenter_HasEncumbrances = null | boolean;

export type TFastFiltersOfferPresenter_HasEquipment = null | boolean;

export type TFastFiltersOfferPresenter_HasExcursions = null | boolean;

export type TFastFiltersOfferPresenter_HasExtinguishingSystem = null | boolean;

export type TFastFiltersOfferPresenter_HasFridge = null | boolean;

export type TFastFiltersOfferPresenter_HasFurniture = null | boolean;

export type TFastFiltersOfferPresenter_HasGarage = null | boolean;

export type TFastFiltersOfferPresenter_HasGas = null | boolean;

export type TFastFiltersOfferPresenter_HasHairdryer = null | boolean;

export type TFastFiltersOfferPresenter_HasHeating = null | boolean;

export type TFastFiltersOfferPresenter_HasInternet = null | boolean;

export type TFastFiltersOfferPresenter_HasInvestmentProject = null | boolean;

export type TFastFiltersOfferPresenter_HasIron = null | boolean;

export type TFastFiltersOfferPresenter_HasJacuzzi = null | boolean;

export type TFastFiltersOfferPresenter_HasKitchenFurniture = null | boolean;

export type TFastFiltersOfferPresenter_HasLift = null | boolean;

export type TFastFiltersOfferPresenter_HasLight = null | boolean;

export type TFastFiltersOfferPresenter_HasParking = null | boolean;

export type TFastFiltersOfferPresenter_HasPhone = null | boolean;

export type TFastFiltersOfferPresenter_HasPool = null | boolean;

export type TFastFiltersOfferPresenter_HasRamp = null | boolean;

export type TFastFiltersOfferPresenter_HasSafeCustody = null | boolean;

export type TFastFiltersOfferPresenter_HasSecondedDocs = null | boolean;

export type TFastFiltersOfferPresenter_HasSecurity = null | boolean;

export type TFastFiltersOfferPresenter_HasShopWindows = null | boolean;

export type TFastFiltersOfferPresenter_HasShower = null | boolean;

export type TFastFiltersOfferPresenter_HasTeaCoffeeSugar = null | boolean;

export type TFastFiltersOfferPresenter_HasTransfer = null | boolean;

export type TFastFiltersOfferPresenter_HasTransportServices = null | boolean;

export type TFastFiltersOfferPresenter_HasTv = null | boolean;

export type TFastFiltersOfferPresenter_HasWasher = null | boolean;

export type TFastFiltersOfferPresenter_HasWater = null | boolean;

export type TFastFiltersOfferPresenter_HasWifi = null | boolean;

export type TFastFiltersOfferPresenter_HasWiredInternet = null | boolean;

export type TFastFiltersOfferPresenter_HomeownerProofs = null | EHomeownerProofs[];

export enum EHomeownerProofs {
  /** Паспорт **/
  Passport = 'passport',
  /** Пользователь прошел проверку в Росреестре **/
  Rosreestr = 'rosreestr',
  /** Пользователь сдает как самозанятый **/
  SelfEmployed = 'selfEmployed',
}
export type TFastFiltersOfferPresenter_HumanizedTimedelta = null | string;

export type TFastFiltersOfferPresenter_Id = null | number;

export type TFastFiltersOfferPresenter_InputType = null | EInputType;

export enum EInputType {
  /** Общий с улицы **/
  CommonFromStreet = 'commonFromStreet',
  /** Общий со двора **/
  CommonFromYard = 'commonFromYard',
  /** Отдельный с улицы **/
  SeparateFromStreet = 'separateFromStreet',
  /** Отдельный со двора **/
  SeparateFromYard = 'separateFromYard',
}
export type TFastFiltersOfferPresenter_IsApartments = null | boolean;

export type TFastFiltersOfferPresenter_IsAuction = null | boolean;

export type TFastFiltersOfferPresenter_IsByCommercialOwner = null | boolean;

export type TFastFiltersOfferPresenter_IsByHomeowner = null | boolean;

export type TFastFiltersOfferPresenter_IsCianPartner = null | boolean;

export type TFastFiltersOfferPresenter_IsColorized = null | boolean;

export type TFastFiltersOfferPresenter_IsCustoms = null | boolean;

export type TFastFiltersOfferPresenter_IsDacha = null | boolean;

export type TFastFiltersOfferPresenter_IsDealRequestSubstitutionPhone = null | boolean;

export type TFastFiltersOfferPresenter_IsDuplicate = null | boolean;

export type TFastFiltersOfferPresenter_IsDuplicatedDescription = null | boolean;

export type TFastFiltersOfferPresenter_IsEnabledCallTracking = null | boolean;

export type TFastFiltersOfferPresenter_IsExcludedFromAction = null | boolean;

export type TFastFiltersOfferPresenter_IsFairplay = null | boolean;

export type TFastFiltersOfferPresenter_IsFavorite = null | boolean;

export type TFastFiltersOfferPresenter_IsFromBuilder = null | boolean;

export type TFastFiltersOfferPresenter_IsHiddenByUser = null | boolean;

export type TFastFiltersOfferPresenter_IsImported = null | boolean;

export type TFastFiltersOfferPresenter_IsInHiddenBase = null | boolean;

export type TFastFiltersOfferPresenter_IsLegalAddressProvided = null | boolean;

export type TFastFiltersOfferPresenter_IsMulti = null | boolean;

export type TFastFiltersOfferPresenter_IsNeedHideExactAddress = null | boolean;

export type TFastFiltersOfferPresenter_IsNew = null | boolean;

export type TFastFiltersOfferPresenter_IsOccupied = null | boolean;

export type TFastFiltersOfferPresenter_IsPaid = null | boolean;

export type TFastFiltersOfferPresenter_IsPenthouse = null | boolean;

export type TFastFiltersOfferPresenter_IsPremium = null | boolean;

export type TFastFiltersOfferPresenter_IsPro = null | boolean;

export type TFastFiltersOfferPresenter_IsRealtyDemonstrationEnabled = null | boolean;

export type TFastFiltersOfferPresenter_IsRecidivist = null | boolean;

export type TFastFiltersOfferPresenter_IsRentByParts = null | boolean;

export type TFastFiltersOfferPresenter_IsStandard = null | boolean;

export type TFastFiltersOfferPresenter_IsTop3 = null | boolean;

export type TFastFiltersOfferPresenter_JkUrl = null | string;

export type TFastFiltersOfferPresenter_KitchenArea = null | TFastFiltersOfferPresenter_KitchenArea_1;

export type TFastFiltersOfferPresenter_KitchenArea_1 = string | number;

export type TFastFiltersOfferPresenter_Kp = null | IKp;

export type TFastFiltersOfferPresenter_Land = null | ILand;

export type TFastFiltersOfferPresenter_Layout = null | ELayout;

export enum ELayout {
  /** Кабинетная **/
  Cabinet = 'cabinet',
  /** Коридорная **/
  Corridorplan = 'corridorplan',
  /** Смешанная **/
  Mixed = 'mixed',
  /** Открытая **/
  OpenSpace = 'openSpace',
}
export type TFastFiltersOfferPresenter_LayoutPhoto = null | IPhoto;

export type TFastFiltersOfferPresenter_Leisure = null | string;

export type TFastFiltersOfferPresenter_LivingArea = null | TFastFiltersOfferPresenter_LivingArea_1;

export type TFastFiltersOfferPresenter_LivingArea_1 = string | number;

export type TFastFiltersOfferPresenter_LoggiasCount = null | number;

export type TFastFiltersOfferPresenter_MaxArea = null | TFastFiltersOfferPresenter_MaxArea_1;

export type TFastFiltersOfferPresenter_MaxArea_1 = string | number;

export type TFastFiltersOfferPresenter_MinArea = null | TFastFiltersOfferPresenter_MinArea_1;

export type TFastFiltersOfferPresenter_MinArea_1 = string | number;

export type TFastFiltersOfferPresenter_MinPriceTotal = null | number;

export type TFastFiltersOfferPresenter_MinPriceTotalPerMonth = null | number;

export type TFastFiltersOfferPresenter_MinPriceTotalPerMonthRur = null | number;

export type TFastFiltersOfferPresenter_MinPriceTotalPerMonthRurForSearch = null | number;

export type TFastFiltersOfferPresenter_MinPriceTotalRur = null | number;

export type TFastFiltersOfferPresenter_MinPriceTotalRurForSearch = null | number;

export type TFastFiltersOfferPresenter_MinVatPriceTotalPerMonthRur = null | number;

export type TFastFiltersOfferPresenter_MinVatPriceTotalRur = null | number;

export type TFastFiltersOfferPresenter_MonthlyIncome = null | IMonthlyIincome;

export type TFastFiltersOfferPresenter_Multiposting = null | IMultiposting;

export type TFastFiltersOfferPresenter_Name = null | string;

export type TFastFiltersOfferPresenter_Newbuilding = null | INewBuildingPresenter;

export type TFastFiltersOfferPresenter_NewbuildingDynamicCalltracking = null | INewbuildingDynamicCalltracking;

export type TFastFiltersOfferPresenter_NewobjectPromoLabel = null | string;

export type TFastFiltersOfferPresenter_Notes = null | IUserNotes;

export type TFastFiltersOfferPresenter_OfferType = null | EOfferType;

export enum EOfferType {
  /** коммерческая **/
  Commercial = 'commercial',
  /** квартиры **/
  Flat = 'flat',
  /** новостройки **/
  Newobject = 'newobject',
  /** загородка **/
  Suburban = 'suburban',
}
export type TFastFiltersOfferPresenter_PermittedUseType = null | EPermittedUseType;

export enum EPermittedUseType {
  /** Cельскохозяйственное использование **/
  Agricultural = 'agricultural',
  /** Деловое управление **/
  BusinessManagement = 'businessManagement',
  /** Общее пользование территории **/
  CommonUseArea = 'commonUseArea',
  /** Высотная застройка **/
  HighriseBuildings = 'highriseBuildings',
  /** Гостиничное обслуживание **/
  HotelAmenities = 'hotelAmenities',
  /** Индивидуальное жилищное строительство (ИЖС) **/
  IndividualHousingConstruction = 'individualHousingConstruction',
  /** Промышленность **/
  Industry = 'industry',
  /** Отдых (рекреация) **/
  Leisure = 'leisure',
  /** Малоэтажное жилищное строительство (МЖС) **/
  LowriseHousing = 'lowriseHousing',
  /** Общественное использование объектов капитального строительства **/
  PublicUseOfCapitalConstruction = 'publicUseOfCapitalConstruction',
  /** Обслуживание автотранспорта **/
  ServiceVehicles = 'serviceVehicles',
  /** Торговые центры **/
  ShoppingCenters = 'shoppingCenters',
  /** Склады **/
  Warehouses = 'warehouses',
}
export type TFastFiltersOfferPresenter_PetsAllowed = null | boolean;

export type TFastFiltersOfferPresenter_PhoneLinesCount = null | number;

export type TFastFiltersOfferPresenter_Phones = null | TFastFiltersOfferPresenter_Phones_1;

export type TFastFiltersOfferPresenter_Phones_1 = IPhoneOfferPresenter[];

export type TFastFiltersOfferPresenter_Photos = null | TFastFiltersOfferPresenter_Photos_1;

export type TFastFiltersOfferPresenter_Photos_1 = IPublicOfferPhotoPresenter[];

export type TFastFiltersOfferPresenter_PlacementType = null | EPlacementType;

export enum EPlacementType {
  /** Помещение в торговом комплексе **/
  ShoppingMall = 'shoppingMall',
  /** Street retail **/
  StreetRetail = 'streetRetail',
}
export type TFastFiltersOfferPresenter_Platform = null | IPlatformObject;

export type TFastFiltersOfferPresenter_PossibleToChangePermittedUseType = null | boolean;

export type TFastFiltersOfferPresenter_PriceChanges = null | TFastFiltersOfferPresenter_PriceChanges_1;

export type TFastFiltersOfferPresenter_PriceChanges_1 = IPriceChangePresenter[];

export type TFastFiltersOfferPresenter_PricePerUnitArea = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaEur = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaPerMonth = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaPerMonthRur = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaPerMonthRurForSearch = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaPerYear = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaPerYearEur = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaPerYearRur = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaPerYearRurForSearch = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaPerYearUsd = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaRur = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaRurForSearch = null | number;

export type TFastFiltersOfferPresenter_PricePerUnitAreaUsd = null | number;

export type TFastFiltersOfferPresenter_PriceTotal = null | number;

export type TFastFiltersOfferPresenter_PriceTotalEur = null | number;

export type TFastFiltersOfferPresenter_PriceTotalPerMonth = null | number;

export type TFastFiltersOfferPresenter_PriceTotalPerMonthEur = null | number;

export type TFastFiltersOfferPresenter_PriceTotalPerMonthRur = null | number;

export type TFastFiltersOfferPresenter_PriceTotalPerMonthRurForSearch = null | number;

export type TFastFiltersOfferPresenter_PriceTotalPerMonthUsd = null | number;

export type TFastFiltersOfferPresenter_PriceTotalRur = null | number;

export type TFastFiltersOfferPresenter_PriceTotalRurForSearch = null | number;

export type TFastFiltersOfferPresenter_PriceTotalUsd = null | number;

export type TFastFiltersOfferPresenter_ProfessionalSearchDuplicatesGroupSize = null | number;

export type TFastFiltersOfferPresenter_ProjectDeclarationUrl = null | string;

export type TFastFiltersOfferPresenter_PromoInfo = null | IPromoInfo;

export type TFastFiltersOfferPresenter_PropertyType = null | EPropertyType;

export enum EPropertyType {
  /** здание **/
  Building = 'building',
  /** помещение свободного назначения **/
  FreeAppointment = 'freeAppointment',
  /** гараж **/
  Garage = 'garage',
  /** производство **/
  Industry = 'industry',
  /** земля **/
  Land = 'land',
  /** офис **/
  Office = 'office',
  /** торговая площадь **/
  ShoppingArea = 'shoppingArea',
  /** склад **/
  Warehouse = 'warehouse',
}
export type TFastFiltersOfferPresenter_PublishTerms = null | IPublishTerms;

export type TFastFiltersOfferPresenter_PublishedUserId = null | number;

export type TFastFiltersOfferPresenter_ReadyBusinessType = null | EReadyBusinessType;

export enum EReadyBusinessType {
  /** Готовый бизнес (legacy значение, потом нужно отказаться) **/
  Other = 'other',
  /** Готовый бизнес **/
  ReadyBusiness = 'readyBusiness',
  /** Арендный бизнес **/
  RentalBusiness = 'rentalBusiness',
}
export type TFastFiltersOfferPresenter_RentByPartsDescription = null | string;

export type TFastFiltersOfferPresenter_RepairType = null | ERepairType;

export enum ERepairType {
  /** Косметический **/
  Cosmetic = 'cosmetic',
  /** Дизайнерский **/
  Design = 'design',
  /** Евроремонт **/
  Euro = 'euro',
  /** Без ремонта **/
  No = 'no',
}
export type TFastFiltersOfferPresenter_RoomArea = null | TFastFiltersOfferPresenter_RoomArea_1;

export type TFastFiltersOfferPresenter_RoomArea_1 = string | number;

export type TFastFiltersOfferPresenter_RoomType = null | ERoomType;

export enum ERoomType {
  /** Оба варианта **/
  Both = 'both',
  /** Смежная **/
  Combined = 'combined',
  /** Изолированная **/
  Separate = 'separate',
}
export type TFastFiltersOfferPresenter_RoomsArea = null | TFastFiltersOfferPresenter_RoomsArea_1;

export type TFastFiltersOfferPresenter_RoomsArea_1 = string | number;

export type TFastFiltersOfferPresenter_RoomsCount = null | number;

export type TFastFiltersOfferPresenter_RoomsForSaleCount = null | number;

export type TFastFiltersOfferPresenter_RosreestrCheck = null | IOfferRosreestrCheck;

export type TFastFiltersOfferPresenter_SelfEmployedData = null | ISelfEmployedData;

export type TFastFiltersOfferPresenter_SeparateWcsCount = null | number;

export type TFastFiltersOfferPresenter_SettlementName = null | string;

export type TFastFiltersOfferPresenter_ShareAmount = null | string;

export type TFastFiltersOfferPresenter_ShowWarningMessage = null | boolean;

export type TFastFiltersOfferPresenter_Similar = null | ISimilarOffers;

export type TFastFiltersOfferPresenter_Specialty = null | ICommercialSpecialty;

export type TFastFiltersOfferPresenter_Statistic = null | IStatistic;

export type TFastFiltersOfferPresenter_TaxNumber = null | number;

export type TFastFiltersOfferPresenter_Title = null | string;

export type TFastFiltersOfferPresenter_TotalArea = null | TFastFiltersOfferPresenter_TotalArea_1;

export type TFastFiltersOfferPresenter_TotalArea_1 = string | number;

export type TFastFiltersOfferPresenter_User = null | IFastFiltersUserPresenter;

export type TFastFiltersOfferPresenter_UserId = null | number;

export type TFastFiltersOfferPresenter_VasType = null | EVasType;

export enum EVasType {
  /** Классическое ранжирование **/
  Classic = 'classic',
  /** ML ранжирование **/
  Ml = 'ml',
}
export type TFastFiltersOfferPresenter_VatPriceTotalPerMonthRur = null | number;

export type TFastFiltersOfferPresenter_VatPriceTotalRur = null | number;

export type TFastFiltersOfferPresenter_Videos = null | TFastFiltersOfferPresenter_Videos_1;

export type TFastFiltersOfferPresenter_Videos_1 = IVideo[];

export type TFastFiltersOfferPresenter_VillageMortgageAllowed = null | boolean;

export type TFastFiltersOfferPresenter_Water = null | IWater;

export type TFastFiltersOfferPresenter_WaterCapacity = null | number;

export type TFastFiltersOfferPresenter_WaterPipesCount = null | number;

export type TFastFiltersOfferPresenter_WaterType = null | EWaterType;

export enum EWaterType {
  /** Автономное **/
  Autonomous = 'autonomous',
  /** Центральное **/
  Central = 'central',
  /** Водонапорная станция **/
  PumpingStation = 'pumpingStation',
  /** Водозаборный узел **/
  WaterIntakeFacility = 'waterIntakeFacility',
  /** Водонапорная башня **/
  WaterTower = 'waterTower',
}
export type TFastFiltersOfferPresenter_WcLocationType = null | EWcLocationType;

export enum EWcLocationType {
  /** В доме **/
  Indoors = 'indoors',
  /** На улице **/
  Outdoors = 'outdoors',
}
export type TFastFiltersOfferPresenter_WcType = null | EWcType;

export enum EWcType {
  /** Совмещенный **/
  Combined = 'combined',
  /** Раздельный **/
  Separate = 'separate',
}
export type TFastFiltersOfferPresenter_WindowsViewType = null | EWindowsViewType;

export enum EWindowsViewType {
  /** На улицу **/
  Street = 'street',
  /** Во двор **/
  Yard = 'yard',
  /** На улицу и двор **/
  YardAndStreet = 'yardAndStreet',
}
export type TFastFiltersOfferPresenter_WithoutClientFee = null | boolean;

export type TFastFiltersOfferPresenter_WorkTimeInfo = null | IWorkTimeInfoPresenter;

export type TFastFiltersOfferPresenter_WorkplaceCount = null | number;
